module.exports = __webpack_public_path__ + "img/4.01974728.jpg";